/* Profils de panier NuovaGlam (09/10/2026). Le tiroir panier est ré-affiché en entier à chaque changement :
   tout passe par une écoute globale (délégation) et un minuteur unique, rien n'est lié aux éléments eux-mêmes.
   Méthode : brain/knowledge/standards/panier-par-profil.md */
(() => {
  if (window.NGCartProfile) return;
  /* Minuteur de réservation : même fin pour toutes les pages de la session (stockage local, comme la source :
     10 min, puis redémarre). Sans stockage disponible : fin gardée en mémoire. */
  const KEY = 'ngcpTimerEnd';
  let memEnd = 0;
  const readEnd = () => { try { return Number(localStorage.getItem(KEY)) || 0; } catch (e) { return memEnd; } };
  const writeEnd = (v) => { memEnd = v; try { localStorage.setItem(KEY, String(v)); } catch (e) {} };
  const tick = () => {
    const els = document.querySelectorAll('[data-ngcp-timer]');
    if (!els.length) return;
    const dur = (Number(els[0].dataset.minutes) || 10) * 60000;
    let end = readEnd(); let left = end - Date.now();
    if (!end || left <= 0 || left > dur) { end = Date.now() + dur; left = dur; writeEnd(end); }
    const mm = String(Math.floor(left / 60000)).padStart(2, '0');
    const ss = String(Math.floor((left % 60000) / 1000)).padStart(2, '0');
    els.forEach((el) => {
      const t = el.querySelector('[data-ngcp-timer-text]');
      if (t) t.textContent = (el.dataset.text || '{time}').replace('{time}', mm + ':' + ss);
    });
  };
  tick(); setInterval(tick, 1000);
  document.addEventListener('DOMContentLoaded', tick);

  /* Tiroir de choix des upsells du panier : cloné depuis son <template> dans un hôte unique sous <body>,
     même largeur que le tiroir panier ; ajout par product-form natif ; refermé dès que le panier est mis à jour. */
  /* Prix (29/10/2026) : mêmes règles que snippets/ng-money.liquid — le format suit la DEVISE, pas la langue.
     EUR : « 74,95 € », point décimal pour l'Irlande en anglais (« 74.95 € ») ; GBP et autres : « £64.00 ». */
  if (!window.NGMoney) {
    window.NGMoney = {
      format(cents) {
        const S = window.Shopify || {};
        const cur = (S.currency && S.currency.active) || 'EUR';
        const n = (Number(cents) || 0) / 100;
        if (cur === 'EUR') {
          const dot = S.country === 'IE' && !(document.documentElement.lang || '').toLowerCase().startsWith('it');
          return new Intl.NumberFormat(dot ? 'en-IE' : 'de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n) + ' €';
        }
        return new Intl.NumberFormat(cur === 'GBP' ? 'en-GB' : 'en-IE', { style: 'currency', currency: cur }).format(n);
      },
    };
  }
  const money = (c) => window.NGMoney.format(c);
  let current = null; let opener = null;
  const host = () => {
    let h = document.getElementById('ngcp-qv-host');
    if (!h) { h = document.createElement('div'); h.id = 'ngcp-qv-host'; document.body.appendChild(h); }
    return h;
  };
  const close = () => {
    const qv = current; if (!qv) return;
    current = null; qv.classList.remove('is-open');
    setTimeout(() => qv.remove(), 320);
    const drawer = document.querySelector('cart-drawer .drawer__inner');
    if (opener && document.body.contains(opener)) opener.focus({ preventScroll: true }); else if (drawer) drawer.focus({ preventScroll: true });
  };
  const bind = (qv) => {
    let variants = [];
    try { variants = JSON.parse(qv.querySelector('[data-ngcp-qv-variants]').textContent); } catch (e) {}
    const idInput = qv.querySelector('[data-ngcp-qv-id]'); const add = qv.querySelector('.ngcp-qv__add');
    const img = qv.querySelector('.ngcp-qv__img img'); const price = qv.querySelector('[data-ngcp-qv-price]');
    const stock = qv.querySelector('[data-ngcp-qv-stock]'); const stockText = qv.querySelector('[data-ngcp-qv-stock-text]');
    const groups = [...qv.querySelectorAll('[data-ngcp-qv-option]')];
    const apply = () => {
      const chosen = groups.map((g) => (g.querySelector('.is-active') || {}).dataset?.value);
      const v = variants.find((x) => x.options.every((o, i) => chosen[i] === undefined || o === chosen[i]));
      if (!v) return;
      idInput.value = v.id;
      if (price) price.textContent = money(v.price);
      if (stock) { stock.classList.toggle('is-out', !v.available); stockText.textContent = v.available ? stock.dataset.in : stock.dataset.out; }
      if (add) add.disabled = !v.available;
      const src = v.featured_image && v.featured_image.src;
      if (img && src) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = src + (src.includes('?') ? '&' : '?') + 'width=600'; }
    };
    groups.forEach((g) => g.querySelectorAll('.ngcp-qv__swatch').forEach((b) => b.addEventListener('click', () => {
      g.querySelectorAll('.ngcp-qv__swatch').forEach((x) => { x.classList.toggle('is-active', x === b); x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
      apply();
    })));
    qv.querySelectorAll('[data-ngcp-qv-close]').forEach((b) => b.addEventListener('click', close));
    qv.addEventListener('keydown', (e) => { if (e.key === 'Escape') { e.stopPropagation(); close(); } });
    /* filet si l'événement cartUpdate n'arrive pas : fin du chargement du bouton sans erreur -> fermeture */
    if (add) new MutationObserver(() => {
      if (add.dataset.ngcpBusy && !add.classList.contains('loading')) {
        const err = qv.querySelector('.product-form__error-message-wrapper');
        if (!err || err.hidden) setTimeout(close, 150);
      }
      if (add.classList.contains('loading')) add.dataset.ngcpBusy = '1';
    }).observe(add, { attributes: true, attributeFilter: ['class'] });
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-ngcp-qv-open]'); if (!b) return;
    const tpl = document.querySelector(`template[data-ngcp-qv-tpl="${b.dataset.ngcpQvOpen}"]`); if (!tpl) return;
    e.preventDefault();
    if (current) current.remove();
    opener = b;
    const h = host(); h.innerHTML = '';
    h.appendChild(tpl.content.cloneNode(true));
    const qv = h.querySelector('[data-ngcp-qv]'); current = qv;
    const ci = document.querySelector('cart-drawer .drawer__inner');
    const w = ci ? ci.getBoundingClientRect().width : 0;
    if (w > 200) qv.querySelector('.ngcp-qv__panel').style.width = w + 'px';
    bind(qv);
    requestAnimationFrame(() => requestAnimationFrame(() => qv.classList.add('is-open')));
    setTimeout(() => qv.querySelector('.ngcp-qv__panel').focus({ preventScroll: true }), 50);
  });
  let hooked = false;
  const hook = () => {
    if (hooked || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    hooked = true;
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => { if (current) close(); });
  };
  document.addEventListener('click', hook, true);
  window.addEventListener('load', hook);
  window.NGCartProfile = { tick, close };
})();
